import { create } from 'zustand';

// The firm-cost overlay (Ctrl+Shift+Y) is a global, firm-employee-only debug
// toggle. Its open/closed state is shared between the `CostStatusBar` (which
// owns the keyboard shortcut) and the per-message token-usage annotations
// rendered deep inside the chat tree — potentially in a sibling subtree (the
// investigation page renders the bar outside the chat experience).
type CostOverlayState = {
  isOpen: boolean;
  set: (next: boolean) => void;
  toggle: () => void;
};
const useStore = create<CostOverlayState>(set => ({
  isOpen: false,
  set: next => set({
    isOpen: next
  }),
  toggle: () => set(state => ({
    isOpen: !state.isOpen
  }))
}));

// Imperative handle for the non-React shortcut owner (CostStatusBar's keydown handlers).
export const costOverlayStore = {
  set: (next: boolean) => useStore.getState().set(next),
  toggle: () => useStore.getState().toggle()
};

/** Subscribe to whether the firm-cost overlay is currently open. */
export const useCostOverlayOpen = () => {
  return useStore(_temp);
};
function _temp(state) {
  return state.isOpen;
}